export default __webpack_public_path__ + "static/media/running-dude.b8f49661.gif";